import moment from "moment/moment";
import Message from "./Message";
import { useEffect, useState } from "react";
import { executeCommand } from "../../services/blip";

import "./styles.scss"
import Search from "./Search";
import Avatar from "../Avatar";

export default function Chat({
    chat: chatAttr,
    contact,
    isLoading
}) {
    const [chat, setChat] = useState([])
    const [search, setSearch] = useState()
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        if (chat)
            document.querySelector(".chat-messages")?.scrollTo(0, 10000000000)
    }, [contact])

    useEffect(async () => {
        for (let item of chatAttr) {
            try {
                for (let key of ["uri", "previewUri"]) {
                    let value = item?.chat?.content?.[key]
                    if (typeof value == "object") value = value?.resource
                    if (value) {
                        const response = await executeCommand({
                            to: "postmaster@media.msging.net",
                            method: "set",
                            uri: "/refresh-media-uri",
                            type: "text/plain",
                            resource: item.chat.content[key]
                        })
                        let newAttr = {}
                        if (typeof response === "string") newAttr = { resource: response }
                        else newAttr = { ...response }
                        item.chat.content[key] = newAttr
                    }
                }
            } catch (error) {
                console.error(error)
            }
        }
        setChat(() => chatAttr)
        setSearch(undefined)
        if (!loaded)
            setLoaded(true)
    }, [chatAttr])

    // function downloadTxtFile(fileName, content) {
    //     const element = document.createElement("a");
    //     const file = new Blob([content], { type: "text/plain" });
    //     element.href = URL.createObjectURL(file);
    //     element.download = fileName;
    //     document.body.appendChild(element); // Necessário para Firefox
    //     element.click();
    //     document.body.removeChild(element);
    // }

    // function generateTranscription() {
    //     try {
    //         // console.log("{ generateTranscription }", chat.length)
    //         let items = []

    //         for (let chatItem of chat.sort((a, b) => a?.reference?.datetime - b?.reference?.datetime)) {
    //             // console.log(JSON.stringify(chatItem))

    //             let { reference, chat: body } = chatItem
    //             let { direction, content } = body

    //             if (content) {
    //                 let { type } = body

    //                 let directionText = direction == "sent" ? "Enviada" : "Recebida"
    //                 let base = `[${directionText}][${moment(reference.datetime).format("DD/MM/YYYY HH:mm")}]`
    //                 let item = `${base}`

    //                 if (type == "text/plain")
    //                     item = `${item} ${content}`
    //                 else if (type == "application/vnd.lime.reply+json")
    //                     item = `${item} ${content.replied.value}`
    //                 else if (content.uri)
    //                     item = `${item}[${content.type}] ${content.uri}`

    //                 items.push(item)
    //             }
    //         }

    //         let txt = items.join("\n")

    //         // console.log(txt)

    //         // if (items.length > 0)
    //         //     downloadTxtFile(`${contact.identity}_${moment().toISOString()}.txt`, txt)
    //     } catch (error) {
    //         console.error(error)
    //     }
    // }

    return (
        <div className="chat-container">
            <div className="chat-top">
                <div className="chat-header">
                    <Avatar url={contact.photoUri} />
                    <div className="contact-info">
                        <p className="name">{contact?.name || contact?.identity}</p>
                        <p className="identity">ID: <span>{contact?.identity}</span></p>
                    </div>
                    <div className="actions">
                        {/* <bds-icon
                            size="large"
                            name="search"
                            className="bp-lh-simple bp-c-cloud bp-fs-5 bds-icon bds-icon__size--x-small hydrated"
                            role="img"
                            aria-label="search"
                            theme="outline"
                            onClick={generateTranscription}
                        ></bds-icon> */}

                        <bds-icon
                            size="large"
                            name="search"
                            className="bp-lh-simple bp-c-cloud bp-fs-5 bds-icon bds-icon__size--x-small hydrated"
                            role="img"
                            aria-label="search"
                            theme="outline"
                            onClick={() => setSearch("")}
                        ></bds-icon>

                        {/* <bds-icon
                            size="large"
                            name="download"
                            className="bp-lh-simple bp-c-cloud bp-fs-5 bds-icon bds-icon__size--x-small hydrated"
                            role="img"
                            aria-label="d"
                            theme="outline"
                            onClick={() => generatePDF(`${ contact?.identity }_${ moment().format("YYYY-MM-DDTHH:mm:ss") } `)}
                        ></bds-icon> */}
                    </div>
                </div>

                <Search
                    chat={chat}
                    setChat={setChat}
                    search={search}
                    setSearch={setSearch}
                />
            </div>

            {isLoading ?
                <div style={{ textAlign: "center", paddingTop: 40 }}>
                    <bds-icon
                        size="brand"
                        name="loading"
                        className="bp-lh-simple bp-c-cloud bp-fs-5 bds-icon bds-icon__size--x-small hydrated"
                        role="img"
                        aria-label="search"
                        theme="outline"
                        lazy="true"
                    ></bds-icon>
                </div> :
                chat.length == 0 ?
                    <div style={{ textAlign: "center", paddingTop: 40 }}>
                        <p>Nenhuma mensagem encontrada</p>
                    </div> :
                    <div className="chat-messages" data-search-opened={search != undefined}>
                        {chat
                            // .filter((item) =>
                            //     !item.chatId ||
                            //     item.chatId.indexOf("quick-link:") < 0
                            // )
                            .map((item, index) =>
                                <div key={index}>
                                    {item?.reference?.type == "message" &&
                                        <>
                                            <Message
                                                _id={item.id}
                                                origin={item.reference.origin}
                                                chatId={item.chatId}
                                                {...item.chat}
                                                createdAt={item?.reference?.datetime || item?.createdAt}
                                                showDatetime={
                                                    moment(item.createdAt).format("DD/MM/YYYY HH:mm") !== moment(chat[index + 1]?.createdAt).format("DD/MM/YYYY HH:mm") ||
                                                    item?.reference?.origin !== chat[index + 1]?.reference?.origin
                                                }
                                                selected={item.selected || false}
                                                chat={chat}
                                            />
                                        </>
                                    }

                                    {item?.reference?.type == "attendanceRedirect" &&
                                        <div className="info">
                                            <p className="info-1">Chatbot {item?.chat?.content?.ownerIdentity?.split("@")?.[0]} encaminhou a conversa para atendimento</p>
                                            <p className="info-2">Ticket #{item?.chat?.content?.sequentialId}</p>
                                        </div>
                                    }
                                </div>
                            )}
                    </div>
            }
        </div>
    )
}